import { AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Button, Spinner, Table, TableContainer, Tbody, Td, Th, Thead, Tr, useDisclosure, useToast } from "@chakra-ui/react";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDeleteUpdateMutation, useGetUpdatesQuery } from "../../features/api/api";

export const UpdatesTable = ({ onSelect }: { onSelect: (id: string) => void }) => {
	const { data, error, isLoading } = useGetUpdatesQuery();
	const clickRow = (id: string | undefined) => {
		if (!id) {
			return;
		}
		onSelect(id);
	};
	if (isLoading || !data) {
		return <Spinner size='xl' />;
	}

	if (error) {
		console.log("error is", error);
		return null;
	}


	return (
		<TableContainer>
			<Table size='sm'>
				<Thead>
					<Tr>
						<Th>Version</Th>
					</Tr>
				</Thead>
				<Tbody>
					{data?.map((row) => (
						<Tr _hover={{
							bg: 'teal.400',
							color: 'white',
							cursor: 'pointer',
						}}
							onClick={() => clickRow(row.id)}
							key={row.id}
						>
							<Td >{row.version}</Td>

						</Tr>
					))}
				</Tbody>
			</Table>
		</TableContainer>
	)
}

export const DeleteUpdateButton = ({ id }: { id: string }) => {
	const { isOpen, onOpen, onClose } = useDisclosure()
	const cancelRef = useRef(null)
	const [deleteUpdate] = useDeleteUpdateMutation();
	const navigate = useNavigate();
	const toast = useToast()
	const deleteF = (id: string) => {
		deleteUpdate(id).unwrap().then(fulfilled => {
			toast({
				title: `Borttagen`,
				status: "success",
				isClosable: true,
			});
		}).catch(err => {
			console.error(err)
			if (err.data.error === 'update.in.use') {
				toast({
					title: `Uppdatering används av någon kontroller. Kan inte tas bort.`,
					status: "error",
					isClosable: true,
				});
				return;
			}
			toast({
				title: `Misslyckades med att ta bort`,
				status: "error",
				isClosable: true,
			});
		});

		navigate('/inside/admin/updates');
	}
	return (
		<>
			<Button mr={6} onClick={onOpen} colorScheme="red" width="100px">Ta bort</Button>
			<AlertDialog
				isOpen={isOpen}
				leastDestructiveRef={cancelRef}
				onClose={onClose}
			>
				<AlertDialogOverlay>
					<AlertDialogContent>
						<AlertDialogHeader fontSize='lg' fontWeight='bold'>
							Ta bort uppdatering
						</AlertDialogHeader>

						<AlertDialogBody>
							Är du säker? Detta går inte att ångra.
						</AlertDialogBody>

						<AlertDialogFooter>
							<Button ref={cancelRef} onClick={onClose}>
								Avbryt
							</Button>
							<Button colorScheme='red' onClick={() => {
								deleteF(id);
								onClose();
							}} ml={3}>
								Ta bort
							</Button>
						</AlertDialogFooter>
					</AlertDialogContent>
				</AlertDialogOverlay>
			</AlertDialog>
		</>
	)
}
